/// <reference path="../_all.ts" />

module menuEditor {

  MenuEntryListDirective.$inject = [
  ];
  export function MenuEntryListDirective(
  ): ng.IDirective {

    return {
      restrict: 'AE',
      scope: {
        menuData: '=',
        selectedEntry: "=",
        nameProperty: '@',
        onHideChange: '&',
      },
      templateUrl: 'menueditor/MenuEntryListDirective',
      link: function (scope: IMenuEditorListDirectiveScope, element: ng.IAugmentedJQuery, attr: ng.IAttributes) {

        scope.nameProperty = angular.isDefined(scope.nameProperty) ? scope.nameProperty : 'Name';

        scope.getActiveClass = function (i) {
          if (i && scope.selectedEntry && i.Id == scope.selectedEntry.Id) return 'active';
        }

        scope.itemDraggedAndDropped = function (item, index) {
          scope.menuData.splice(index, 1);
          scope.selectedEntry = item;
          var modify = scope.menuData[index];
          modify.Modified = true;
        }

        scope.swapItems = function (index1, index2) {
          var temp = scope.menuData[index1];
          scope.menuData[index1] = scope.menuData[index2];
          scope.menuData[index2] = temp;
          
          scope.menuData[index1].Modified = true; 
          scope.menuData[index2].Modified = true;
        }

        scope.moveItemUp = function (index) {
          scope.swapItems(index, index - 1);
        }

        scope.moveItemDown = function (index) {
          scope.swapItems(index, index + 1);
        }

        scope.selectEntry = function (i) {
          scope.selectedEntry = i;
        }


      }
    }
  }
}